import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Top 5 Funding NTB Syariah"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "5 Cabang terbaik dalam mendapatkan pasar berdasarkan jumlah client")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-120px" })
  ])
], -1)
const _hoisted_8 = { class: "symbol symbol-50px" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_11 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block fs-7" }, " Rating ", -1)
const _hoisted_13 = { class: "rating" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-light-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-twitter fs-4" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-light-facebook btn-sm"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-facebook fs-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([[index === 0 && 'show active'], "tab-pane fade"]),
            id: `kt_table_widget_4_tab_${index + 1}`
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item1, index1) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index1 }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: item1.image,
                            alt: ""
                          }, null, 8, _hoisted_9)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", _hoisted_10, _toDisplayString(item1.user.name), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(item1.user.position), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                            return _createElementVNode("div", {
                              key: i,
                              class: _normalizeClass([[item1.rating >= i && 'checked'], "rating-label me-2"])
                            }, _hoisted_15, 2)
                          }), 64))
                        ])
                      ]),
                      _hoisted_16
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ], 2))
}